import { useTranslationInternal } from '../core/TranslationProvider';

/**
 * Hook para obtener la función de traducción
 * Uso: const { translate, t } = useTranslation();
 *
 * `translate`/`t` aceptan un segundo argumento OPCIONAL con los valores de los marcadores
 * `{{nombre}}` de la traducción: `t('grid.detail', { number: 7 })`. Sin él se comportan igual que
 * siempre, así que ninguna llamada existente cambia.
 *
 * Además de `translate`/`t` expone:
 * - `currentLanguage`: idioma activo, útil para resolver diccionarios locales.
 * - `resolve`: resolución con procedencia (`{ value, lang }` o `null`). A
 *   diferencia de `t`, distingue una traducción del idioma activo de un fallback
 *   al idioma base; es lo que permite a un consumidor con diccionarios propios
 *   priorizar su traducción del idioma activo. Ver `TranslationEngine.resolve`.
 * - `refreshTranslations`: invalida la caché y recarga el catálogo del backend.
 * - `resourceVersion`: cambia cuando llega un catálogo fresco (útil como
 *   dependencia de `useMemo`/`useCallback` que memoricen textos traducidos).
 */
export const useTranslation = () => {
  const {
    translate,
    t,
    resolve,
    isReady,
    error,
    currentLanguage,
    refreshTranslations,
    resourceVersion,
  } = useTranslationInternal();

  return {
    translate,
    t,
    resolve,
    isReady,
    error,
    currentLanguage,
    refreshTranslations,
    resourceVersion,
  };
};
